import type { EntryType } from "../../public/js/Compo/CompoPage";

export interface CompoCategoriesJSON {
  category_1: string;
  category_2: string;
  category_3: string;
  category_4: string;
  category_5: string;
  category_6: string;
  category_7: string;
  category_8: string;
  category_9: string;

  type: EntryType;
}

export class CompoCategoriesClient implements CompoCategoriesJSON {
  constructor(props?: any) {
    if (!props) {
      return;
    }

    for (const key in props) {
      (this as any)[key] = props[key];
    }
  }

  get list(): string[] {
    return [
      this.category_1,
      this.category_2,
      this.category_3,
      this.category_4,
      this.category_5,
      this.category_6,
      this.category_7,
      this.category_8,
      this.category_9,
    ].filter((x) => !!x);
  }

  id!: number;

  compo_id!: number;
  category_1!: string;
  category_2!: string;
  category_3!: string;
  category_4!: string;
  category_5!: string;
  category_6!: string;
  category_7!: string;
  category_8!: string;
  category_9!: string;
  type!: EntryType;
}
